module.exports = __webpack_public_path__ + "static/Pt05-d62ddff146766b471b6f34e5cb1309fe.jpg";